import { IHttpConfig } from 'utils/http/httpClient.model';

export default (config: IHttpConfig): IHttpConfig => {
  if (config.timeOut === undefined) {
    return { ...config, timeOut: window.sgmeConfiguration.defaultTimeoutMs };
  }
  return config;
};
